import style from './icon.module.scss'

export const VegaIconTypes = {
	DEFAULT: style.icon,
	ROUNDED: style.rounded,
	SQUARED: style.squared
}
